import {Department} from '@/shared/types/common.ts';
import {ServiceWithNames} from '@/shared/types/service.ts';
import {useOutletContext} from 'react-router';

/**
 * Context passed through Outlet to child routes in AuthenticatedLayout.
 */
export type AuthenticatedOutletContext = {
    employeeId: string;
    employeeName: string;
    employeeDepartment: Department | null;
    onEditService?: (service: ServiceWithNames) => void;
};

/**
 * Hook to access the authenticated outlet context from child routes.
 * Provides the employee name for use in employee-specific views.
 *
 * @example
 * ```tsx
 * const EmployeeView = () => {
 *   const { employeeName } = useAuthenticatedContext();
 *   return <div>Hello, {employeeName}</div>;
 * };
 * ```
 */
export const useAuthenticatedContext = (): AuthenticatedOutletContext => {
    return useOutletContext<AuthenticatedOutletContext>();
};
